import React, { FC, ReactNode, useState } from 'react';
import styled from 'styled-components';

import FlexColumn from '@ui/atoms/FlexColumn';

import useMemberInsurance from '@hooks/useMemberInsurance';

import { IInsuranceProviderSelection, InsuranceContext } from '@providers/InsuranceProvider';

import theme from '@theme/FolxTheme';

interface IInsuranceRouteProps {
	children: ReactNode;
	path?: string;
}

const InsuranceLayout = styled(FlexColumn)`
	gap: ${theme.spacing.lg};
	max-width: 64rem;
	width: 100%;
`;

const InsuranceRoute: FC<IInsuranceRouteProps> = ({ children }) => {
	const [provider, setProvider] = useState<IInsuranceProviderSelection | undefined>();

	const { memberInsurance, loading: memberInsuranceLoading } = useMemberInsurance();

	return (
		<InsuranceLayout>
			<InsuranceContext.Provider
				value={{
					provider,
					setProvider,
					memberInsurance,
					memberInsuranceLoading,
				}}>
				{children}
			</InsuranceContext.Provider>
		</InsuranceLayout>
	);
};

export default InsuranceRoute;
